let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8e9HE")).then(() => parcelRequire('e9jSz'));